import Forgot from './Forgot';
import ForgotConfirmForm from './ForgotConfirmForm';
import ForgotForm from './ForgotForm';
import ForgotPasswordForm from './ForgotPasswordForm';
export { Forgot, ForgotConfirmForm, ForgotForm, ForgotPasswordForm };
export default Forgot;
